import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import { TIPO_PARAMETRO } from '../../../../constants/utilConstants'
import { useConciliacaoContext } from '../../../../contexts/conciliacao-context'
import { PAGES } from '../../../../router/routes'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { Acao, Condicao } from '../../../../types/regraApiType'
import { converterToAcaoNotaFiscalForm, converterToCondicaoNotaFiscalForm } from '../../../../utils/regraFormsUtils'
import { estaVazio } from '../../../../utils/stringUtils'
import { PreviewItemNotaFiscal, RegraNotaFiscal, RegraNotaFiscalForm } from '../../../../types/notaFiscalApiTypes'
import notaFiscalManager from '../../../../services/api/notaFiscal/notaFiscalManager'
import { RegraNotaFiscalFormProps } from './RegraNotaFiscalForm.View'

const dadosIniciaisFormulario: RegraNotaFiscalForm = {
  nomeRegra: '',
  campo: 'TipoLancamento',
  condicoes: [],
  acoes: []
}

export function regraNotaFiscalFormIO({ regraNotaFiscalEditar }: RegraNotaFiscalFormProps) {
  const router = useHistory()
  const dispatch = useDispatch()
  const { parceiroId, regraId } = useParams<{ parceiroId: string; regraId: string }>()
  const { headersData, getHeadersPlanilha } = useConciliacaoContext()
  const [arquivoId, setArquivoId] = useState('')
  const [acaoList, setAcaoList] = useState<Acao[]>([])
  const [condicaoList, setCondicaoList] = useState<Condicao[]>([])
  const [preVisualizar, setpreVisualizar] = useState<PreviewItemNotaFiscal>()
  const [openModal, setOpenModal] = useState(false)
  const [save, setSave] = useState(false)
  const [switchAtivo, setSwitchAtivo] = useState(regraNotaFiscalEditar?.ativo)

  const retornarValoresUnicos = (arrayAvaliado: string[]) => {
    return arrayAvaliado.filter((valor, index, valorComparado) => valorComparado.indexOf(valor) === index)
  }

  const popularDropDownDados = () => {
    if (!regraNotaFiscalEditar) {
      return []
    }

    let headersArray: string[] = []

    headersArray = regraNotaFiscalCondicao(regraNotaFiscalEditar, headersArray)
    headersArray = regrasNotaFiscalAcao(regraNotaFiscalEditar, headersArray)

    return retornarValoresUnicos(headersArray)
  }

  const [fieldDado, setFieldDado] = useState(popularDropDownDados())

  const parametrosForm = useForm<RegraNotaFiscalForm>({
    defaultValues: regraNotaFiscalEditar
      ? {
          ...regraNotaFiscalEditar,
          acoes: converterToAcaoNotaFiscalForm(regraNotaFiscalEditar.acoes),
          condicoes: converterToCondicaoNotaFiscalForm(regraNotaFiscalEditar.condicoes)
        }
      : dadosIniciaisFormulario
  })

  useEffect(() => {
    async function buscarCondicoes() {
      const response: Condicao[] = await notaFiscalManager.buscarCondicoes()
      setCondicaoList(response)
    }

    async function buscarAcoes() {
      const response: Acao[] = await notaFiscalManager.buscarAcoes()
      setAcaoList(response)
    }

    dispatch(loadingUpdate(true))
    buscarCondicoes()
    buscarAcoes()
    dispatch(loadingReset())
  }, [dispatch, parceiroId])

  useEffect(() => {
    if (headersData && headersData.length != 0) setFieldDado(headersData)
  }, [headersData])

  const handlePreview = async () => {
    const regraForm: RegraNotaFiscalForm = parametrosForm.getValues()

    if (arquivoId) {
      dispatch(loadingUpdate(true))

      await notaFiscalManager
        .previewRegra(regraForm, arquivoId)
        .then((response: PreviewItemNotaFiscal) => {
          setpreVisualizar(response)
          setOpenModal(true)
        })
        .catch(() => {
          toast.error(msgConstants.ERRO_PRE_VISUALIZACAO)
        })
        .finally(() => {
          dispatch(loadingReset())
        })
    } else {
      toast.error(msgConstants.ARQUIVO.uploadPreVisualizarErro)
    }
  }

  const handleCancelar = () => {
    getHeadersPlanilha([])
    router.push(PAGES.transformacaoNotaFiscal(parceiroId))
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const mudarStatusParaAtivo = (event: any) => {
    setSwitchAtivo(event.target.checked)
  }

  const salvarDados = async (data: RegraNotaFiscalForm) => {
    async function cadastrarRegra() {
      await notaFiscalManager
        .cadastrarRegra(data, parceiroId)
        .then(() => {
          toast.success(msgConstants.USO_GENERICO.cadastro_sucesso)
          dispatch(loadingReset())
          save ? parametrosForm.reset() : router.push(PAGES.transformacaoNotaFiscal(parceiroId))
        })
        .catch(() => dispatch(loadingReset()))
    }
    dispatch(loadingUpdate(true))

    cadastrarRegra()
    !save && getHeadersPlanilha([])
  }

  const editarDados = (data: RegraNotaFiscalForm) => {
    async function editarRegra() {
      data.ativo = switchAtivo

      await notaFiscalManager
        .editarRegra(data, parceiroId, regraId)
        .then(() => {
          toast.success(msgConstants.USO_GENERICO.edicao_sucesso)
          dispatch(loadingReset())
          router.push(PAGES.transformacaoNotaFiscal(parceiroId))
        })
        .catch(() => {
          dispatch(loadingReset())
          toast.error(msgConstants.USO_GENERICO.edicao_erro)
        })
    }
    dispatch(loadingUpdate(true))

    editarRegra()
    getHeadersPlanilha([])
  }

  const enviarDadosFormulario = (data: RegraNotaFiscalForm) => {
    return handleRegraNotaFiscal(editarDados, data, salvarDados, regraId)
  }

  return {
    setArquivoId,
    parametrosForm,
    enviarDadosFormulario,
    mudarStatusParaAtivo,
    switchAtivo,
    condicaoList,
    acaoList,
    fieldDado,
    handlePreview,
    handleCancelar,
    setSave,
    openModal,
    handleCloseModal,
    preVisualizar,
    regraId
  }
}

export type RegraNotaFiscalFormIO = ReturnType<typeof regraNotaFiscalFormIO>

function handleRegraNotaFiscal(
  editarDados: (data: RegraNotaFiscalForm) => void,
  data: RegraNotaFiscalForm,
  salvarDados: (data: RegraNotaFiscalForm) => Promise<void>,
  regraId?: string
) {
  return regraId ? editarDados(data) : salvarDados(data)
}

function regraNotaFiscalCondicao(regraNotaFiscal: RegraNotaFiscal, arrayCondicao: string[]) {
  regraNotaFiscal.condicoes.forEach((condicao) => {
    arrayCondicao.push(condicao.dado)
    const parametroPreenchido = !estaVazio(condicao.parametro.parametro)
    const parametroIgualColuna = condicao.parametro.tipoParametro.tipoParametroId === TIPO_PARAMETRO.coluna
    if (parametroPreenchido && parametroIgualColuna) {
      arrayCondicao.push(condicao.parametro.parametro)
    }
  })
  return arrayCondicao
}

function regrasNotaFiscalAcao(regraNotaFiscal: RegraNotaFiscal, arrayAcao: string[]) {
  regraNotaFiscal.acoes.forEach((acao) => {
    const dadosAcaoPreenchida = !estaVazio(acao.dado)
    const acaoPreenchida = !estaVazio(acao.parametro.parametro)
    const parametroIgualColuna = acao.parametro.tipoParametro.tipoParametroId === TIPO_PARAMETRO.coluna
    if (dadosAcaoPreenchida) arrayAcao.push(acao.dado)
    if (parametroIgualColuna && acaoPreenchida) {
      arrayAcao.push(acao.parametro.parametro)
    }
  })
  return arrayAcao
}
